module.exports = __webpack_public_path__ + "assets/fef0579cb757bec11a47263d06e15770.png";